<div class="flex-direction-column gap-5">
  <span class="font-12 weight-600">{{ label }}</span>
  @if (carregandoInfo) {
    <div class="skeleton" [style.width]="widthFormField" style="height: 35px;"></div>
  } @else {
    <mat-form-field appearance="outline" class="datepicker-customizado" [style.width]="widthFormField">
      <mat-icon matPrefix (click)="picker.open()" style="cursor: pointer;">calendar_month</mat-icon>
      <input matInput [matDatepicker]="picker" [formControl]="dataControl" [min]="dataMinima" [placeholder]="placeholder">
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  }
</div>
